module.exports = __webpack_public_path__ + "img/fron-elemenet.0998084b.png";